import { useLeftNavigationUrlQueryParams } from '~/features/catalog/hooks/useLeftNavigationUrlQueryParams';
import { useBasePath } from '~/common/hooks/useBasePath';

/**
 * This hook returns the path to the article detail page. It includes the left navigation query parameters, to keep the current search/category selection state.
 * @param articleNumber Article number
 */
export function useArticleDetailPath(articleNumber: string) {
  const leftNavigationUrlQueryParams = useLeftNavigationUrlQueryParams();
  const { path } = useBasePath();

  return `${path}/catalog/article/${articleNumber}?${leftNavigationUrlQueryParams.toString()}`;
}
